import '../Sidebar/Sidebardigital';
import Sidebarfarmcompany from '../Sidebar/Sidebarfarmcompany';
import Sidebarblank from '../Sidebar/Sidebarblank';
import React from 'react';
import Input_shop from '../images/Inputs_shop.png';

export default function Farmcompany()
{
    return(
       <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebarfarmcompany />
        </div>
        <div className="col-8 custom-width">
            <br/><br/><br/>
        <h5>We work with Agri-inputs companies to bring technology angle to their inputs shop:</h5><br></br><br></br>
        <img src={Input_shop} className="img-fluid" alt="Why Gatisheel" loading="lazy" width="100%" height="auto" />
        <br/><br/><br></br>
        <h6>Farmer expectations are changing from the inputs shop. Farmers want to see new technologies and approaches are getting shared by agri-inputs companies through their farmer facing centers.
          We partner with these agri-inputs companies and help their farmers get access to the latest IOT technologies </h6><br></br><br></br>
        </div>
        <div className="col-2 custom-display">
          <Sidebarblank />
        </div>
        </div>
     </>
    )   
   };